import { Cabal } from "types";
import { useNavigatePreserveQuery } from "lib/hooks/useNavigatePreserveQuery";
import DefaultAvatarIcon from "assets/icons/default-avatar.png";
import { useCallback } from "react";

interface CabalWithShills extends Cabal {
  shills?: number;
  cabalCall?: any[];
  totalCalls?: number;
  change?: number;
}

interface CabalFreeGroupRowV2Props {
  cabal: CabalWithShills;
  rank: number;
  onClick: () => void;
}

const withGroupRowItem = (Component: React.ComponentType<any>) => {
  return ({ cabal, rank = 1, onClick }: CabalFreeGroupRowV2Props) => {
    const { tgGroupId } = cabal;

    const navigate = useNavigatePreserveQuery();
    const handleOnError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
      event.currentTarget.src = DefaultAvatarIcon;
    };

    const navigateToCabalDetailPage = useCallback(() => {
      onClick();
      navigate(`/cabal/${tgGroupId}`);
    }, [tgGroupId]);

    return (
      <Component
        cabal={cabal}
        rank={rank}
        navigateTo={navigateToCabalDetailPage}
        handleOnError={handleOnError}
      />
    );
  };
};

export { withGroupRowItem, type CabalFreeGroupRowV2Props, type CabalWithShills };
